import moment from "moment";

// This is a factory function (also called a higher-order function)
function chainablePropType(isRequired) {
	// The factory returns a custom prop type
	return (props, propName) => {
		const prop = props[propName];

		if (prop == null) {
			// Prop is missing
			if (isRequired) {
				throw new Error(`Missing ${propName}`);
			}
			// Prop is optional. Do nothing.
		} else {
			// Put your validation logic here...
			const isMoment = moment.isMoment(prop);
			const isString = typeof prop === "string";

			if (!isMoment && !isString) {
				return new Error(`Expected ${propName} to be a moment or a string.`);
			}
		}

		// assume all ok
		return null;
	};
}

// Using the factory, create two different versions of your prop type
const datePicker = chainablePropType(false);
datePicker.isRequired = chainablePropType(true);

export default datePicker;
